import styled from 'styled-components'

import loginBackground from '../../assets/images/login-background.svg'
import { LoadingWrapper } from '../../shared/components/Loading/styles'
import {
	fontType,
	mediaQuery,
	toRem,
	transition,
} from '../../shared/styles/functions'

export const LoginWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	padding: 48px 24px;
	background-color: ${({ theme }) => theme.colors.lightWhite};
	background-image: url(${loginBackground});
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;

	/* o design usa tracking tight (-4%) em toda a tipografia da tela */
	letter-spacing: -0.04em;

	.login-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		min-width: 0;
		max-width: ${toRem(480)};
		gap: 40px;
	}

	.logo {
		width: ${toRem(130)};
		max-width: 100%;
		height: auto;
		object-fit: contain;
	}

	.login-header {
		text-align: center;

		.kicker {
			${fontType(0)}
			font-size: ${toRem(14)};
			color: ${({ theme }) => theme.colors.neutralGrey};
			margin-bottom: 10px;
		}

		.title {
			${fontType(1)}
			font-size: ${toRem(28)};
			line-height: ${toRem(40)};
			letter-spacing: -0.04em;
			color: ${({ theme }) => theme.colors.black};
		}
	}

	.login-card {
		width: 100%;
		background: ${({ theme }) => theme.colors.white};
		border-radius: ${toRem(20)};
		padding: 40px 32px;
		box-shadow: 0 12px 32px ${({ theme }) => `${theme.colors.blue}14`};

		form {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
	}

	.remember {
		display: flex;
		align-items: center;
		gap: 16px;
		cursor: pointer;
		${fontType(0)}
		font-size: ${toRem(14)};
		color: ${({ theme }) => theme.colors.neutralGrey};

		input {
			appearance: none;
			-webkit-appearance: none;
			flex-shrink: 0;
			width: 20px;
			height: 20px;
			margin: 0;
			border: solid 1px ${({ theme }) => theme.colors.secondaryLightGrey};
			border-radius: 4px;
			background: ${({ theme }) => theme.colors.white};
			cursor: pointer;
			${transition()}

			&:checked {
				background: ${({ theme }) => theme.colors.blue};
				border-color: ${({ theme }) => theme.colors.blue};
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FFFFFF' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
				background-size: 14px 14px;
				background-position: center;
				background-repeat: no-repeat;
			}

			&:focus-visible {
				outline: none;
				box-shadow: 0 0 0 3px ${({ theme }) => `${theme.colors.blue}1F`};
			}
		}
	}

	.button {
		margin-top: 8px;

		button {
			width: 100%;
			min-height: 56px;
			padding: 16px 32px;
		}

		${LoadingWrapper} {
			padding: 0;
		}
	}

	${mediaQuery('sm')(`
		padding: 32px 16px;

		.login-card {
			padding: 28px 20px;
		}

		.login-content {
			gap: 28px;
		}

		.login-header .title {
			font-size: 1.5rem;
		}

		.logo {
			width: 7.5rem;
		}
	`)}
`
